<div class="relative flex flex-col w-full h-full">

  <!-- Dismiss button -->
  @if (data.dismissible) {
  <div class="absolute top-0 right-0 pt-4 pr-4">
    <button mat-icon-button [matDialogClose]="undefined">
      <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
    </button>
  </div>
  }

  <!-- Content -->
  <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start p-8 pb-6 sm:pb-8">

    <!-- Icon -->
    @if (data.icon.show) {
    <div class="flex flex-0 items-center justify-center w-10 h-10 sm:mr-4 rounded-full" [ngClass]="{'text-primary-600 bg-primary-100 dark:text-primary-50 dark:bg-primary-600': data.icon.color === 'primary',
                            'text-accent-600 bg-accent-100 dark:text-accent-50 dark:bg-accent-600': data.icon.color === 'accent',
                            'text-warn-600 bg-warn-100 dark:text-warn-50 dark:bg-warn-600': data.icon.color === 'warn',
                            'text-gray-600 bg-gray-100 dark:text-gray-50 dark:bg-gray-600': data.icon.color === 'basic',
                            'text-blue-600 bg-blue-100 dark:text-blue-50 dark:bg-blue-600': data.icon.color === 'info',
                            'text-green-500 bg-green-100 dark:text-green-50 dark:bg-green-500': data.icon.color === 'success',
                            'text-amber-500 bg-amber-100 dark:text-amber-50 dark:bg-amber-500': data.icon.color === 'warning',
                            'text-red-600 bg-red-100 dark:text-red-50 dark:bg-red-600': data.icon.color === 'error'
                            }">
      <mat-icon class="text-current" [svgIcon]="data.icon.name"></mat-icon>
    </div>
    }

    @if (data.title || data.message) {
    <div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">
      <!-- Title -->
      @if (data.title) {
      <div class="text-xl leading-6 font-medium" [innerHTML]="data.title"></div>
      }
      <!-- Message -->
      @if (data.message) {
      <div class="text-secondary" [innerHTML]="data.message"></div>
      }
      <!-- Input -->
      @if (data.nameInput) {
      <form [formGroup]="inputForm" class="w-full">

        <!-- Toggle PICE (solo si hay empresas disponibles en modo 1 Y el usuario es ADMIN) -->
        @if (data.mode === 1 && data.companies && data.isAdmin) {
        <div class="mt-6 mb-4 flex items-center justify-between">
          <div class="flex flex-col">
            <label class="text-sm font-medium text-gray-700">¿Es Consultor PICE?</label>
            <p class="text-xs text-gray-500 mt-1">Consultor que gestiona múltiples empresas</p>
          </div>
          <mat-slide-toggle (click)="togglePice()" [checked]="isPice" color="primary">
          </mat-slide-toggle>
        </div>
        }

        <!-- Toggle Mode -->
        @if (inputForm.get('generate_with_ai')) {
        <div class="flex flex-col items-center justify-center w-full mt-4 mb-8">
          <div class="flex bg-gray-200 dark:bg-gray-800 rounded-full p-1 cursor-pointer">
            <div class="px-4 py-2 rounded-full transition-colors font-medium text-sm"
              [ngClass]="!inputForm.get('generate_with_ai').value ? 'bg-white text-primary shadow' : 'text-gray-500 hover:text-gray-900'"
              (click)="inputForm.get('generate_with_ai').setValue(false)">
              Manual
            </div>
            <div class="px-4 py-2 rounded-full transition-colors font-medium text-sm flex items-center"
              [ngClass]="inputForm.get('generate_with_ai').value ? 'bg-white text-primary shadow' : 'text-gray-500 hover:text-gray-900'"
              (click)="inputForm.get('generate_with_ai').setValue(true)">
              <mat-icon class="icon-size-4 mr-1"
                [ngClass]="inputForm.get('generate_with_ai').value ? 'text-yellow-500' : 'text-gray-400'"
                [svgIcon]="'heroicons_solid:sparkles'"></mat-icon>
              Con Inteligencia Artificial
            </div>
          </div>
          @if (inputForm.get('generate_with_ai').value) {
          <div class="mt-4 text-sm text-center text-gray-500 dark:text-gray-400 max-w-sm">
            Introduzca el título del perfil profesional y una descripción (opcional para mayor contexto), y la IA
            completará el resto de campos en el siguiente paso.
          </div>
          }
        </div>
        }

        @if (inputForm.get('name')) {
        <div class="mt-6">
          <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-label>{{ data.nameInput }}</mat-label>
            <input [formControlName]="inputValue" [formControlName]="'name'" matInput>
          </mat-form-field>
        </div>
        }
        @if (inputForm.get('lastname')) {
        <div class="mt-6">
          <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-label>Apellidos</mat-label>
            <input [formControlName]="'lastname'" matInput>
          </mat-form-field>
        </div>
        }
        @if (inputForm.get('email')) {
        <div class="mt-6">
          <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-label>Email</mat-label>
            <input [formControlName]="'email'" matInput type="email" required>
            @if (inputForm.get('email')?.hasError('required')) {
            <mat-error>
              El email es obligatorio
            </mat-error>
            }
            @if (inputForm.get('email')?.hasError('email') && !inputForm.get('email')?.hasError('required')) {
            <mat-error>
              Introduce un email válido
            </mat-error>
            }
          </mat-form-field>
        </div>
        }
        @if (inputForm.get('phone')) {
        <div class="mt-6">
          <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-label>Teléfono</mat-label>
            <input [formControlName]="'phone'" matInput type="tel" placeholder="Ej: +123456789">
          </mat-form-field>
        </div>
        }

        <!-- Company (solo si NO es PICE) -->
        @if (inputForm.get('company_id') && showCompanyField()) {
        <div class="mt-6">
          <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-label>Empresa</mat-label>
            <input matInput formControlName="company_id" [matAutocomplete]="companyAutocomplete"
              placeholder="Selecciona o busca empresa">
            <mat-autocomplete #companyAutocomplete="matAutocomplete" [displayWith]="displayCompanyName.bind(this)">
              <mat-option *ngFor="let company of filteredCompanies$ | async" [value]="company">
                {{company.name}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="inputForm.get('company_id')?.hasError('required')">
              La empresa es obligatoria
            </mat-error>
          </mat-form-field>
        </div>
        }

        @if (inputForm.get('description')) {
        <div class="mt-6">
          <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-label>Descripción</mat-label>
            <textarea [formControlName]="'description'" matInput rows="3"
              placeholder="Descripción del perfil profesional (opcional)"></textarea>
          </mat-form-field>
        </div>
        }

      </form>
      }
    </div>
    }

  </div>


  <!-- Actions -->
  @if (data.actions.confirm.show || data.actions.cancel.show) {
  <div
    class="flex items-center justify-center sm:justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">
    <!-- Cancel -->
    @if (data.actions.cancel.show) {
    <button mat-stroked-button [matDialogClose]="'cancelled'">
      {{data.actions.cancel.label}}
    </button>
    }
    <!-- Confirm -->
    @if (data.actions.confirm.show) {
    <button mat-flat-button [disabled]="(validate)?null:'disabled'" [color]="data.actions.confirm.color"
      (click)="closeDialog()">
      {{data.actions.confirm.label}}
    </button>
    }
  </div>
  }

</div>